import { useState } from 'react';
import { FaUserPlus } from 'react-icons/fa';
import { apiNode } from '../../../../services/api';
import { Container, Content } from './styles';

import { SyncOutlined } from '@ant-design/icons';

interface UserProps {
  id: number;
  name: string;
  sobrenome: string;
  foto: string;
}

interface CardProps {
  user: UserProps;
  openSuccessModal: (user: UserProps) => void;
}

export const Card: React.FC<CardProps> = ({
  user,
  openSuccessModal,
}: CardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleInvitePlayerToLeague = async () => {
    try {
      setIsLoading(true);

      const response = await apiNode.get('/ligas/users');
      const leagueId = response.data.liga.id;

      await apiNode.post('/convites', {
        userId: user.id,
        ligaId: leagueId,
      });

      openSuccessModal(user);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Content>
        <span>
          <img
            src={
              user.foto
                ? user.foto
                : 'https://www.pinclipart.com/picdir/middle/157-1578186_user-profile-default-image-png-clipart.png'
            }
            alt={`Foto de ${user.name}`}
          />
        </span>

        <div>
          <span>
            <h1>{user.name}</h1>
          </span>
        </div>

        <button
          type="button"
          {...(!isLoading && { onClick: handleInvitePlayerToLeague })}
        >
          {isLoading ? <SyncOutlined spin /> : <FaUserPlus />}
        </button>
      </Content>
    </Container>
  );
};
